// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  font-size: 45px;
  cursor: pointer;
  transition: 0.15s linear;
}

ion-label {
  font-size: 35px;
  margin: 0 20px;
  cursor: pointer;
  min-width: 60px;
}

.container-button-command {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: relative;
  top: -60px;
  z-index: 99999;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/gauge-circular/gauge-circular.component.scss","webpack://./src/components/general%20components/gauge-circular/gauge-circular.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,eAAA;EACA,wBAAA;ACCJ;;ADGA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;ACAJ;;ADGA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;ACAJ","sourcesContent":["ion-icon {\n    font-size: 45px;\n    cursor: pointer;\n    transition: .15s linear;\n}\n\n\nion-label {\n    font-size: 35px;\n    margin: 0 20px;\n    cursor: pointer;\n    min-width: 60px;\n}\n\n.container-button-command{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: row;\n    position: relative;\n    top: -60px;\n    z-index: 99999;\n}\n","ion-icon {\n  font-size: 45px;\n  cursor: pointer;\n  transition: 0.15s linear;\n}\n\nion-label {\n  font-size: 35px;\n  margin: 0 20px;\n  cursor: pointer;\n  min-width: 60px;\n}\n\n.container-button-command {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  position: relative;\n  top: -60px;\n  z-index: 99999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
